import React from "react";
import MatchComparisonProgressBar2 from "./MatchComparisonProgressBar2.js";
import classes from "./MatchStats2.module.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import i18n from "../../locales/i18n.js";

const STATS = [
    { label: "Ball Possession", homeVal: "homeTeamPossession", awayVal: "awayTeamPossession", possession: true },
    { label: "Total Shots", homePct: "homeTeamTotalShotsPer", awayPct: "awayTeamTotalShotsPer", homeVal: "homeTeamTotalShots", awayVal: "awayTeamTotalShots" },
    { label: "Shots On Goal", homePct: "homeTeamShotsOnGoalPer", awayPct: "awayTeamShotsOnGoalPer", homeVal: "homeTeamShotsOnGoal", awayVal: "awayTeamShotsOnGoal" },
    { label: "Shots Off Goal", homePct: "homeTeamShotsOffGoalPer", awayPct: "awayTeamShotsOffGoalPer", homeVal: "homeTeamShotsOffGoal", awayVal: "awayTeamShotsOffGoal" },
    { label: "Passes", homePct: "homeTeamPassesPer", awayPct: "awayTeamPassesPer", homeVal: "homeTeamPasses", awayVal: "awayTeamPasses" },
    { label: "Fouls", homePct: "homeTeamFoulsPer", awayPct: "awayTeamFoulsPer", homeVal: "homeTeamFouls", awayVal: "awayTeamFouls" },
    { label: "Corner Kicks", homePct: "homeTeamCornerPer", awayPct: "awayTeamCornerPer", homeVal: "homeTeamCorner", awayVal: "awayTeamCorner" },
    { label: "Offsides", homePct: "homeTeamOffsidesPer", awayPct: "awayTeamOffsidesPer", homeVal: "homeTeamOffsides", awayVal: "awayTeamOffsides" },
    { label: "Yellow Cards", homePct: "homeTeamYellowCardPer", awayPct: "awayTeamYellowCardPer", homeVal: "homeTeamYellowCard", awayVal: "awayTeamYellowCard" },
    { label: "Red Cards", homePct: "homeTeamRedCardPer", awayPct: "awayTeamRedCardPer", homeVal: "homeTeamRedCard", awayVal: "awayTeamRedCard" },
];

const STATS_SW = [
    { label: "Umiliki wa Mpira", homeVal: "homeTeamPossession", awayVal: "awayTeamPossession", possession: true },
    { label: "Jumla ya Mashuti", homePct: "homeTeamTotalShotsPer", awayPct: "awayTeamTotalShotsPer", homeVal: "homeTeamTotalShots", awayVal: "awayTeamTotalShots" },
    { label: "Mashuti Lielengwa", homePct: "homeTeamShotsOnGoalPer", awayPct: "awayTeamShotsOnGoalPer", homeVal: "homeTeamShotsOnGoal", awayVal: "awayTeamShotsOnGoal" },
    { label: "Mashuti Nje ya Lengo", homePct: "homeTeamShotsOffGoalPer", awayPct: "awayTeamShotsOffGoalPer", homeVal: "homeTeamShotsOffGoal", awayVal: "awayTeamShotsOffGoal" },
    { label: "Pasi", homePct: "homeTeamPassesPer", awayPct: "awayTeamPassesPer", homeVal: "homeTeamPasses", awayVal: "awayTeamPasses" },
    { label: "Faulo", homePct: "homeTeamFoulsPer", awayPct: "awayTeamFoulsPer", homeVal: "homeTeamFouls", awayVal: "awayTeamFouls" },
    { label: "Kona", homePct: "homeTeamCornerPer", awayPct: "awayTeamCornerPer", homeVal: "homeTeamCorner", awayVal: "awayTeamCorner" },
    { label: "Otesaid/Kuotea", homePct: "homeTeamOffsidesPer", awayPct: "awayTeamOffsidesPer", homeVal: "homeTeamOffsides", awayVal: "awayTeamOffsides" },
    { label: "Kadi za Njano", homePct: "homeTeamYellowCardPer", awayPct: "awayTeamYellowCardPer", homeVal: "homeTeamYellowCard", awayVal: "awayTeamYellowCard" },
    { label: "Kadi Nyekundu", homePct: "homeTeamRedCardPer", awayPct: "awayTeamRedCardPer", homeVal: "homeTeamRedCard", awayVal: "awayTeamRedCard" },
];

const MatchStats2 = ({ teamStatistics }) => {

    const { t } = useTranslation();

    const { selectedLanguage } = useSelector((state) => state.languageSlice);

    if (!teamStatistics) return null;

    return (
        <div className={classes.container}>

            {/* Team logos header */}
            <div className={classes.teamsHeader}>
                <div className={classes.headerTeam}>
                    <div className={classes.headerLogoWrap}>
                        <img src={teamStatistics?.homeTeamLogo} alt={teamStatistics?.homeTeamName} className={classes.headerLogo} />
                    </div>
                    <span className={classes.headerTeamName}>{teamStatistics?.homeTeamName}</span>
                </div>
                <span className={classes.headerLabel}>{t("126")}</span>
                <div className={`${classes.headerTeam} ${classes.headerTeamRight}`}>
                    <div className={classes.headerLogoWrap}>
                        <img src={teamStatistics?.awayTeamLogo} alt={teamStatistics?.awayTeamName} className={classes.headerLogo} />
                    </div>
                    <span className={classes.headerTeamName}>{teamStatistics?.awayTeamName}</span>
                </div>
            </div>

            {/* Stat rows */}
            <div className={classes.rows}>
                {(selectedLanguage == 0 ? STATS : STATS_SW).map(({ label, homePct, awayPct, homeVal, awayVal, possession }) => {
                    const v1 = teamStatistics?.[homeVal] ?? 0;
                    const v2 = teamStatistics?.[awayVal] ?? 0;
                    const p1 = possession
                        ? parseFloat(String(v1).replace("%", "")) || 0
                        : (teamStatistics?.[homePct] ?? 0);
                    const p2 = possession
                        ? parseFloat(String(v2).replace("%", "")) || 0
                        : (teamStatistics?.[awayPct] ?? 0);

                    return (
                        <MatchComparisonProgressBar2
                            key={label}
                            name={label}
                            percentage1={p1}
                            percentage2={p2}
                            value1={v1}
                            value2={v2}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default MatchStats2;